import { ReactNode, useCallback } from 'react';
import { components } from '@api/play-account/generated';

import { cx } from '@libs/classnames';
import { CapsuleButton } from '@ui/components/CapsuleButton';
import { ArrowSlimIcon } from '@ui/icons/ArrowSlimIcon';

import { PlayerGamesList } from '@features/user/ui/PlayerGamesList/PlayerGamesList';

import styles from './PlayerGamesListPreview.module.css';

type Props = {
  className?: string;
  games: components['schemas']['UserGameHistoryItemDto'][];
  isCollapsed: boolean;
  onCollapsedChange: (isCollapsed: boolean) => void;
  onShowAll: () => void;
  onGameClick: (game: components['schemas']['UserGameHistoryItemDto']) => void;
  renderShieldQuickPeek: (userId: string) => ReactNode;
};
export function PlayerGamesListPreview({
  className,
  games,
  isCollapsed,
  onCollapsedChange,
  onShowAll,
  onGameClick,
  renderShieldQuickPeek,
}: Props) {
  const onExpand = useCallback(() => onCollapsedChange(false), [onCollapsedChange]);
  const onCollapse = useCallback(() => onCollapsedChange(true), [onCollapsedChange]);

  return (
    <div className={cx(styles.gamesListPreview, className)}>
      <div className={cx(styles.gamesList, { [styles.collapsed]: isCollapsed })}>
        <PlayerGamesList
          games={games}
          onGameClick={onGameClick}
          renderShieldQuickPeek={renderShieldQuickPeek}
        />
      </div>

      <div className={styles.buttonBar}>
        {isCollapsed ? (
          <CapsuleButton
            className={styles.button}
            preset="hollow-golden"
            size="16r-32"
            onClick={onExpand}
          >
            <span>Показать игры</span>
            <span className={cx(styles.arrow, styles.down)}>
              <ArrowSlimIcon />
            </span>
          </CapsuleButton>
        ) : (
          <>
            <CapsuleButton
              className={styles.button}
              preset="hollow-golden"
              size="16r-32"
              onClick={onCollapse}
            >
              <span>Свернуть</span>
              <span className={cx(styles.arrow, styles.up)}>
                <ArrowSlimIcon />
              </span>
            </CapsuleButton>
            <CapsuleButton
              className={styles.button}
              preset="hollow-golden"
              size="16r-32"
              onClick={onShowAll}
            >
              <span>Показать все</span>
              <span className={cx(styles.arrow, styles.right)}>
                <ArrowSlimIcon />
              </span>
            </CapsuleButton>
          </>
        )}
      </div>
    </div>
  );
}
